
import { defineComponent } from "vue";
import RecentProducts from "@/components/products/recent-products.vue"; // @ is an alias to /src

export default defineComponent({
  name: "HomeView",
  components: {
    RecentProducts,
  },
});
